import {Input, InputGroup, InputLeftElement, useTheme} from '@chakra-ui/react'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  register: (name: any, options?: any) => any
}

const EmailInput = ({register}: Props) => {
  const theme = useTheme()
  const {t} = useTranslation('profile')

  return (
    <InputGroup>
      <InputLeftElement color={theme.colors.brand.white}>
        <FontAwesomeIcon icon={faEnvelope} />
      </InputLeftElement>
      <Input
        id='email'
        placeholder={t('profile_email_placeholder')}
        {...register('email', {
          required: t('profile_input_required'),
          pattern: {
            value: /^[^@]+@[^@]+\.[^@]+$/i,
            message: t('profile_input_email_invalid'),
          },
        })}
      />
    </InputGroup>
  )
}

export default EmailInput
